/**
 * Shared components used throughout the application.
 * For complex components with significant logic, create separate files.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { styled } from '@mui/material';
import WarningOutlined from '@mui/icons-material/WarningOutlined';

/** Error message component with warning icon */
export const Error = ({ message }: { message: string }) => (
    <ErrorGrid>
        <WarningOutlined />
        {message}
    </ErrorGrid>
);

/** Component that scrolls to top when route changes */
export const ScrollToTopOnPageChange = () => {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);
    return null;
};

const TwoColumnGrid = styled('div')`
    display: grid;
    grid-template-columns: auto max-content;
    grid-gap: ${({ theme }) => theme.spacing(1)};
    align-items: center;
`;

const ErrorGrid = styled(TwoColumnGrid)`
    color: ${({ theme }) => theme.palette.error.main};
`;
